<template>
  <VCard outlined elevated="0">
    <VCardText class="pb-0">
      {{ $t('profileComplited', { percent: status.percent }) }}
    </VCardText>
    <VCardText>
      <VProgressLinear
        color="success"
        :value="status.percent"
        class="mb-5"
      />
      <p v-if="status.recommendations && status.recommendations.length > 0">
        {{ $t('left') }}: <br>
        <span
          v-for="r of status.recommendations"
          :key="r.recommendation"
        >
          - {{ r.recommendation }} <span class="primary--text">(+{{ r.points }}%)</span><br>
        </span>
      </p>
      <a :href="companyLink" target="_blank">
        {{ $t('viewProfile') }}
      </a>
    </VCardText>
  </VCard>
</template>

<script>
export default {
  name: 'CompanyStatusPanel',
  props: {
    company: {
      type: Object,
      required: true,
    },
  },
  computed: {
    status() {
      return this.company.profileCompleteness;
    },
    companyLink() {
      return `${process.env.VUE_APP_FRONT_URL}/company/${this.company.id}`;
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
  profileComplited: 'Profile is {percent}% complete'
  left: Left to complete
  viewProfile: View company profile
</i18n>

<i18n locale="ru" lang="yaml">
  profileComplited: 'Профиль заполнен на {percent}%'
  left: Осталось заполнить
  viewProfile: Смотреть профиль компании
</i18n>
